const select2Utils = {
    allWordsMatcher(params, data) {
        const term = (params.term || "").toUpperCase();
        if (term.trim() === "") {
            return data;
        }

        // Поиск по слову в целом
        const textUpperCase = data.text.toUpperCase();
        if (textUpperCase.indexOf(term) >= 0) {
            return data;
        }

        // Проверка, что все слова входят в текст
        const words = term.split(" ");
        return words.every(w => textUpperCase.indexOf(w) >= 0) ? data : null;
    }
};

export default select2Utils;